module.exports = __webpack_public_path__ + "img/personal_center.6b01f76c.png";